import React from 'react';
import { SITE_NAME } from '../../utils/Constants';

const Footer: React.FC = () => {
    return (
        <footer className="bg-primary text-white p-4 mt-4">
            <div className="container mx-auto text-center">
                <p className="text-sm">© {new Date().getFullYear()} {SITE_NAME}. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
